import { render } from "./TxDetails.vue?vue&type=template&id=652980c4&scoped=true"
import script from "./TxDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TxDetails.vue?vue&type=script&setup=true&lang=js"

import "./TxDetails.vue?vue&type=style&index=0&id=652980c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652980c4"],['__file',"scripts/dashboard/TxDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "652980c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('652980c4', __exports__)) {
    api.reload('652980c4', __exports__)
  }
  
  module.hot.accept("./TxDetails.vue?vue&type=template&id=652980c4&scoped=true", () => {
    api.rerender('652980c4', render)
  })

}


export default __exports__